import { createContext, useState } from "react";

const ErrorContext = createContext({
  popUpData: 0,
  setPopUpData: (data) => {},
});

export const ErrorContextProvider = (props) => {
  const [data, setData] = useState(0);

  const handleData = (data) => {
    setData(data);
  };

  return (
    <ErrorContext.Provider
      value={{ popUpData: data, setPopUpData: handleData }}
    >
      {props.children}
    </ErrorContext.Provider>
  );
};

export default ErrorContext;
